import { Actions, actionsFor, actionTypesFor, TableActionTypes } from "../table/table.actions"

export const types: TableActionTypes = actionTypesFor("TEMPLATE_TABLE")
export const actions: Actions = actionsFor("TEMPLATE_TABLE")
